export default __webpack_public_path__ + "static/media/accounting.08b28ee9.svg";